// src/router/index.js 路由配置
import Vue from 'vue';
import VueRouter from 'vue-router';
import Layout from '../layout/Layout.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/login/index.vue'),
    meta: { title: '登录' }
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('../views/dashboard/index.vue'),
        meta: { title: '控制台' }
      }
    ]
  },
  {
    path: '/',
    component: Layout,
    redirect: '/article',
    children: [
      {
        path: 'article',
        name: 'Article',
        component: () => import('../views/article/index.vue'),
        meta: { title: '人防知识管理' }
      },
      {
        path: 'shelter',
        name: 'Shelter',
        component: () => import('../views/shelter/index.vue'),
        meta: { title: '掩蔽点管理' }
      },
      {
        path: 'notice',
        name: 'Notice',
        component: () => import('../views/notice/index.vue'),
        meta: { title: '预警通知管理' }
      },
      {
        path: 'alarm',
        name: 'Alarm',
        component: () => import('../views/alarm/index.vue'),
        meta: { title: '防空警报管理' }
      },
      {
        path: 'user',
        name: 'User',
        component: () => import('../views/user/index.vue'),
        meta: { title: '用户管理', roles: ['admin'] }
      },
      {
        path: 'admin',
        name: 'Admin',
        component: () => import('../views/admin/index.vue'),
        meta: { title: '管理员账号', roles: ['admin'] }
      },
      {
        path: 'audit',
        name: 'AuditLog',
        component: () => import('../views/audit/index.vue'),
        meta: { title: '操作审计', roles: ['admin'] }
      },
      {
        path: 'settings',
        name: 'SystemSettings',
        component: () => import('../views/settings/index.vue'),
        meta: { title: '系统配置', roles: ['admin'] }
      }
    ]
  }
];

const router = new VueRouter({
  mode: 'hash',
  routes
});

// 路由守卫：未登录跳转登录页
router.beforeEach((to, from, next) => {
  const token = sessionStorage.getItem('token');
  if (to.path !== '/login' && !token) {
    next('/login');
  } else if (to.path !== '/login' && to.meta.roles) {
    const admin = JSON.parse(sessionStorage.getItem('admin') || 'null');
    const role = admin && admin.role ? admin.role.toLowerCase() : '';
    next(to.meta.roles.includes(role) ? undefined : '/dashboard');
  } else {
    next();
  }
});

export default router;
